export class PauseState {
}
